<template>
    <div class="inline-block media-request__container" tabindex="0" role="button" :aria-label="text">
        <div class="media-request__preview-image" :class="{'no-border':noBorder, 'active':highLight}">
            <i class="fa fa-times media-request__preview-image__delete_button" v-if="allowDelete" @click="del"></i>
            <i class="fa fa-pencil media-request__preview-image__edit_button" v-if="allowEdit" @click="edit"></i>
            <i class="fa" :class="iconClass" aria-hidden="true"></i>
        </div>
        <div class="media-request__preview-image__text">{{text}}</div>
    </div>

</template>

<script>
    export default {
        props: {
            text: {
                type: String
            },
            iconClass: {
                type: String,
            },
            noBorder: {
                type: Boolean,
                default: false
            },
            allowDelete: {
                type: Boolean,
                default: false
            },
            allowEdit: {
                type: Boolean,
                default: false
            },
            highLight: {
                type: Boolean,
                default: false
            }
        },
        name: "MediaPreviewAddRequest"
    };
</script>

<style scoped lang="scss">
    @use "../../angular/app/styles/const" as *;

    $media-holder-size: 300px;
    .media-request {
        &__container {
            cursor: pointer;
            text-align: center;
        }

        &__preview-image {
            vertical-align: top;
            width: 100px;
            height: 70px;
            border-radius: 5px;
            background-color: var(--color-surface);
            text-align: center;

            .fa {
                // stylelint-disable-next-line declaration-property-unit-disallowed-list -- icon sized with its box
                font-size: 45px;
                // stylelint-disable-next-line declaration-property-unit-disallowed-list -- icon sized with its box
                line-height: 70px;
            }

            transition: box-shadow 0.2s linear;

            @mixin iconOverMedia {
                position: absolute;
                cursor: pointer;
                display: block;
                width: 30px;
                height: 30px;
                text-align: center;
                // stylelint-disable-next-line declaration-property-unit-disallowed-list -- placed on the media
                font-size: 30px;
                right: 0;
            }

            &__delete_button {
                @include iconOverMedia;
                color: $red;
                top: -2px;
            }

            &__edit_button {
                @include iconOverMedia;
                color: $dark-blue;
                bottom: 0;
            }

            &__text {
                font-size: 0.875rem;
                font-weight: bolder;
            }

            &:not(.no-border) {
                box-shadow: var(--color-shadow) 0px 0px 10px;

            }

            border: solid 1px;

            &.active {
                box-shadow: $blue 0px 0px 10px;
                border: solid 1px $blue;
            }
        }


    }


</style>